import MapsViewer from './MapsViewer';

export default MapsViewer;
